import MyCollapse from 'components/Collapse';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import Spin from 'components/Spin';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { loadProductAccess } from 'store/Orbita/Invoice/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  classes: any;
  invoice: any;
  access: any;
  historyAccess: any;
}

interface IStates {
  openedLinks: boolean;
  openedHistoric: boolean;
}

class AccessContent extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      openedLinks: true,
      openedHistoric: false,
    };
  }

  showListProductAcess = async () => {
    try {
      if (!this.props.invoice.id) {
        return;
      }

      this.props.dispatch(loadProductAccess(this.props.invoice.id));
    } catch (error) {
      toast.error(error);
    }
  };

  handleClickAccess = () => {
    if (!this.state.openedLinks) {
      this.setState({
        openedLinks: true,
      });

      this.showListProductAcess();
    }
  };

  componentDidMount() {
    this.showListProductAcess();
  }

  render() {
    const { classes, access } = this.props;

    return (
      <div className={classes.access}>
        <h4>Acesso ao Conteúdo</h4>
        <div className='access__content'>
          <div className='access__row'>
            {/* access */}
            <MyCollapse onClick={this.handleClickAccess} title='Links de acesso e download' arrow={true} contentActive={true}>
              {access && access.isFetching && (
                <div className='loading' style={{ height: '100%' }}>
                  <Spin tip='Carregando ...' />
                </div>
              )}

              {access && !access.isFetching && !access.data && !access.files && !access.url_login && (
                <p style={{ padding: '0', margin: '0', fontSize: '14px' }}>Nenhum acesso ou download disponível</p>
              )}

              {!access.isFetching &&
                access &&
                access.files &&
                access.files.length > 0 &&
                access.files.map((file: any, i: number) => (
                  <div
                    key={'files' + i}
                    style={{
                      width: '100%',
                      marginBottom: '0.5rem',
                      border: '1px solid #eee',
                      background: '#fff',
                      borderRadius: '4px',
                      padding: '1rem',
                    }}
                  >
                    <p style={{ fontSize: '14px', fontWeight: 600, lineHeight: '14px', marginBottom: '4px' }}>{file.title}</p>
                    <CustomCopyToClipboard fullWidth text={file.url_download} disableUnderline={true} />
                  </div>
                ))}

              {!access.isFetching &&
                access &&
                access.url_login &&
                access.url_login.length > 0 &&
                access.url_login.map((url: any, i: number) => (
                  <div style={{ width: '100%', margin: '10px 0' }} key={'login-' + i}>
                    <CustomCopyToClipboard fullWidth key={'urls' + i} text={url} disableUnderline={true} />
                  </div>
                ))}
            </MyCollapse>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    historyAccess: state.orbita.Invoice.historyAccess,
  };
}

export default connect(mapStateToProps)(AccessContent);
